export const SESSION_STORAGE_KEYS = {
  UCS_IS_DIGITAL_ONLY_CARD: 'ucsIsDigitalOnlyCard',
  UCS_TOAST_MESSAGES: 'ucsToastMessages',
  PAGE_ALERTS: 'pageAlerts',
  BANNER_ALERT_TYPE: 'banner-alert_type',
  BANNER_ALERT_MESSAGE: 'banner-alert_message',
  BANNER_ALERT_PAYLOAD: 'banner-alert_payload',
  BDMC_ADDRESS_UPDATE_BANNER_STATE: 'bdmcAddressUpdateBannerState',
  CONFIRM_CARD_ADDRESS_BANNER_STATE: 'confirmCardAddressBannerState',
  PPDC_GET_CARD_CLICKED: 'ppdcGetCardClicked',
}
